// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3rfjq","upload":"Small_upload__OU637","imageWrap":"Small_imageWrap__2BOv9","removeBtn":"Small_removeBtn__1jDel"};